import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Products, ProductsState } from "../../types/types";

export const getProducts = createAsyncThunk<Products[], void>(
  "Products/getProducts",
  async () => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;
    const response = await fetch(`${API_URL}/api/v1/products`);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const products = await response.json();
    console.log("Products API response:", products);
    const formattedData = products.map((product: any) => ({
      id: product.id,
      title: product.title,
      description: product.description,
      duration_text: product.duration_text,
      price: product.price,
      view_order: product.view_order,
      tag: product.tag,
      product_category: product.product_category,
    }));
    console.log("formattedData:", formattedData);
    return formattedData;
  }
);

const initialState: ProductsState = {
  productsArr: [] as Products[],
  loading: false,
  error: null,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.productsArr = action.payload;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export default productsSlice.reducer;
